import { getApi } from '../api';
import type { AccountExceptionsListParams } from '../shipment-exception-types';

/**
 * Download CSV for the filtered exceptions list (browser save).
 * `ids` are sent as a comma-separated query value so they always appear in the URL
 * (app axios uses qs with indices:false; a single `ids=1,2,3` is unambiguous).
 */
export async function downloadAccountExceptionsExport(
  accountId: number,
  params: AccountExceptionsListParams = {},
): Promise<void> {
  const { api, baseURL } = getApi();
  const { ids, ...rest } = params;
  const query: Record<string, unknown> = { ...rest };
  if (ids != null && ids.length > 0) {
    query.ids = ids.join(',');
  }
  const res = await api.get(`/api/v2/accounts/${accountId}/exceptions/export`, {
    baseURL,
    params: query,
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `shipment-exceptions-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
